export var componentSpacing01 = 1;
export var componentSpacing02 = 2;
export var componentSpacing03 = 3;
export var componentSpacing04 = 4;
export var componentSpacing05 = 5;
export var componentSpacing06 = 6;
export var componentSpacing07 = 7;
export var componentSpacing08 = 8;
export var componentSpacing09 = 9;
export var layoutSpacing01 = 2;
export var layoutSpacing02 = 3;
export var layoutSpacing03 = 6;
export var layoutSpacing04 = 8;
export var layoutSpacing05 = 10;